// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__2Kz3d","body":"styles_body__3rFAb","footer":"styles_footer__39zWM","cancel":"styles_cancel__1AjRA"};